import React, { useEffect } from "react";
import "../../../../../Assets/Styles/SimpleTextInput.scss";

const TextAreaNoLabel = (props) => {
  useEffect(() => {
    setTimeout(() => {
      if (
        document.getElementById(props.Id) !== null &&
        document.getElementById(props.Id).value.length > 0
      ) {
        addFilledState();
        document
          .getElementById(props.Id + "-placeholder")
          .classList.add("hidden");
      }
    }, 100);
  }, []);
  const handleBlurElement = (e) => {
    if (e.target.value.length > 0) {
      addFilledState();
    } else {
      removeActiveState();
      removeFilledState();
    }
  };
  const addActiveState = () => {
    document.getElementById(props.Id).classList.add("active");
    removeFilledState();
  };
  const removeActiveState = () => {
    document.getElementById(props.Id).classList.remove("active");
  };
  const addFilledState = () => {
    document.getElementById(props.Id).classList.add("filled");
    document.getElementById(props.Id).classList.remove("active");
  };
  const removeFilledState = () => {
    document.getElementById(props.Id).classList.remove("filled");
  };
  const handleChange = (e) => {
    let Value = e.target.value;
    if (Value.length > 0) {
      document
        .getElementById(props.Id + "-placeholder")
        .classList.add("hidden");
      addActiveState();
    } else {
      document
        .getElementById(props.Id + "-placeholder")
        .classList.remove("hidden");
    }
    props.ChangeEvent();
  };
  return (
    <label id={props.Id + "-textarea-holder"} className="cx-simple-text-input">
      <p className="placeholder" id={props.Id + "-placeholder"}>
        {props.PlaceHolder}
      </p>
      <textarea
        onFocus={() => addActiveState()}
        onBlur={(e) => handleBlurElement(e)}
        id={props.Id}
        className="cx-textarea"
        onChange={(e) => handleChange(e)}
        defaultValue={props.InitialValue ? props.InitialValue : ""}
      />
      <p className="validation-message">{props.ValidationMessage} </p>
    </label>
  );
};
export default TextAreaNoLabel;
